module.exports = __webpack_public_path__ + "static/media/dial_logo.64031c24.png";